<template>
    <Breadcrumbs main="Front Office" title="Joining" />
    <div class="container-fluid">
        <div class="email-wrap">
            <div class="row">
                <out-of-stocks-table />
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';
const OutOfStocksTable = defineAsyncComponent(() => import('@/components/stocks/out-of-stocks/out-of-stocks-table.vue'));
</script>